import { render } from "./SelfPayReviewedCases.vue?vue&type=template&id=236fe236"
import script from "./SelfPayReviewedCases.vue?vue&type=script&lang=js"
export * from "./SelfPayReviewedCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/SelfPayReviewedCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "236fe236"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('236fe236', __exports__)) {
    console.log('reload')
    api.reload('236fe236', __exports__)
  }
  
  module.hot.accept("./SelfPayReviewedCases.vue?vue&type=template&id=236fe236", () => {
    console.log('re-render')
    api.rerender('236fe236', render)
  })

}


export default __exports__